/** Policy Directus « RH » (créée avec cet identifiant par `provision-hr-directus.mjs`). Accès complet aux fiches volontaires, hors historique. */
export const HR_POLICY_ID = '0ca121bd-c368-4b0c-b03c-b6605b6dd4da'
